var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F53F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51959 9.99175C4.74433 8.76701 7.98557 8 11.9691 8C14.468 8 16.7567 8.30928 18.4021 8.86598C20.0722 9.43505 20.9876 10.2268 20.9876 11.1052V13.1959L21 13.2082C21 13.233 20.9876 13.2577 20.9876 13.2948C20.9381 13.6289 20.7897 13.9258 20.5546 14.1608C20.233 14.4825 19.7876 14.6433 19.3423 14.5814L16.6825 14.2722C15.9031 14.1979 15.3464 13.5794 15.3464 12.8L15.2722 11.4268L15.1856 11.4021C14.0103 11.1175 12.9464 10.9814 11.932 10.9814C10.9175 10.9814 9.85361 11.1175 8.67835 11.4021L8.60412 11.4268V12.8124C8.60412 13.2206 8.45567 13.5918 8.17113 13.8639C7.92371 14.1113 7.61443 14.2474 7.26804 14.2845L4.62062 14.5814H4.47216C4.08866 14.5938 3.7299 14.4577 3.45773 14.1979C3.16082 13.9258 3 13.5299 3 13.1093V11.068C3.01237 10.6845 3.18557 10.3258 3.51959 9.99175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.18cbe8a3d13fb60048e2879d612db5f8.svg";
export { ForwardRef as ReactComponent };